/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { TransformToOrder } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * StoreQuotesTransformApi - axios parameter creator
 * @export
 */
export const StoreQuotesTransformApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Transform store quotes
         * @summary Transform store quote to order
         * @param {string} storeId The store identifier.
         * @param {TransformToOrder} [body] The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeQuotesTransform: async (storeId: string, body?: TransformToOrder, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('storeQuotesTransform', 'storeId', storeId)
            const localVarPath = `/store/{storeId}/resources/quote/transformToOrder`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreQuotesTransformApi - functional programming interface
 * @export
 */
export const StoreQuotesTransformApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoreQuotesTransformApiAxiosParamCreator(configuration)
    return {
        /**
         * Transform store quotes
         * @summary Transform store quote to order
         * @param {string} storeId The store identifier.
         * @param {TransformToOrder} [body] The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeQuotesTransform(storeId: string, body?: TransformToOrder, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransformToOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeQuotesTransform(storeId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StoreQuotesTransformApi - factory interface
 * @export
 */
export const StoreQuotesTransformApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoreQuotesTransformApiFp(configuration)
    return {
        /**
         * Transform store quotes
         * @summary Transform store quote to order
         * @param {string} storeId The store identifier.
         * @param {TransformToOrder} [body] The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeQuotesTransform(storeId: string, body?: TransformToOrder, options?: any): AxiosPromise<TransformToOrder> {
            return localVarFp.storeQuotesTransform(storeId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoreQuotesTransformApi - object-oriented interface
 * @export
 * @class StoreQuotesTransformApi
 * @extends {BaseAPI}
 */
export class StoreQuotesTransformApi extends BaseAPI {
    /**
     * Transform store quotes
     * @summary Transform store quote to order
     * @param {string} storeId The store identifier.
     * @param {TransformToOrder} [body] The body data required for the REST method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreQuotesTransformApi
     */
    public storeQuotesTransform(storeId: string, body?: TransformToOrder, options?: any) {
        return StoreQuotesTransformApiFp(this.configuration).storeQuotesTransform(storeId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
